// Shared helpers for Reports UI

export const isSmallScreen = () => typeof window !== 'undefined' && window.innerWidth < 768;

export const getSummaryFields = (cols) => {
  if (!Array.isArray(cols)) return [];
  const preferred = ['NAME', 'Name', 'HSE NO', 'HSE', 'UNIT', 'BALANCE', 'BAL', 'BAL.CARRIED FWD', 'PHONE NO', 'PHONE'];
  const picked = [];
  for (const key of preferred) {
    const match = cols.find(c => String(c).toLowerCase() === key.toLowerCase());
    if (match && !picked.includes(match)) picked.push(match);
    if (picked.length >= 3) break;
  }
  if (picked.length < 3) {
    for (const c of cols) {
      if (!picked.includes(c)) picked.push(c);
      if (picked.length >= 3) break;
    }
  }
  return picked.slice(0, 3);
};


